<div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-40 card">
  <div class="flex-horizontal gap-24">
    <div class="flex-vertical gap-8">
      <div class="body-1">
        Vous pouvez ajouter ci-dessous des précisions complémentaires qui seront ajoutées dans les différentes parties
        du PDF.
      </div>
    </div>
    <div class="flex-1"></div>
    <oui-button type="outlined" (click)="onPreview()">Prévisualiser le document</oui-button>
  </div>
  <div class="flex-vertical gap-8" *ngIf="shouldShowEnveloppeComment">
    <div class="body-1">Justification complémentaire sur le choix Enveloppe :</div>
    <oui-textarea
      class="width-100pc"
      [control]="controlEnveloppe"
      placeholder="Saisissez vos précisions (facultatif)"
      [resizeEnabled]="true"></oui-textarea>
  </div>
  <div class="flex-vertical gap-8">
    <div class="body-1">Justification complémentaire sur le choix de l'Allocation :</div>
    <oui-textarea
      class="width-100pc"
      [control]="controlAllocation"
      placeholder="Saisissez vos précisions (facultatif)"
      [resizeEnabled]="true"></oui-textarea>
  </div>
  <div class="flex-vertical gap-8">
    <div class="body-1">Justification complémentaire du caractère approprié du projet global :</div>
    <oui-textarea
      class="width-100pc"
      [control]="controlAutre"
      placeholder="Saisissez vos précisions (facultatif)"
      [resizeEnabled]="true"></oui-textarea>
  </div>
</div>
